
import HlxButton from "../../commonComponents/button/button";
import React from "react";
import Typography from "../../commonComponents/Typography";
import GeneralDialog from "../generalDialog/generalDialog";
import {  Grid } from '@mui/material';



export interface IDeleteCommentDialogProps {
  isOpen: boolean,
  handleDelete: () => {},
  handleClose: () => {},
  locale: any
}

const DeleteCommentDialog = ({
	isOpen,
	handleDelete,
	handleClose,
	locale,
}: IDeleteCommentDialogProps) => {
  const content = (
    <Grid item container>
      <div className="text-dialog-content">
        <Typography>{locale?.heading}</Typography>
      </div>
    </Grid>
  );

  const buttonSubmit = (
    <HlxButton
      label={locale?.txtDelete}
      onClick={handleDelete}
    />
  );

  return (
    <GeneralDialog
      classname="delete-comment-dialog"
      isOpen={isOpen}
      content={content}
      buttonSubmit={buttonSubmit}
      handleClose={handleClose}
      disableBackdropClick={true}
      headerBackgroundDefault={false}
      cancelLabel={locale?.txtCancel}
      title={locale?.title}
    />
  );
};

DeleteCommentDialog.defaultProps = {
  isOpen: true,
  handleDelete: () => {},
  handleClose: () => {},
  locale: {
    title: "Confirmation",
    heading: "Are you sure want to delete?",
    txtDelete: "Delete",
    txtCancel: "Cancel"
  }
};
export default DeleteCommentDialog;
